import React from "react";

import { FormattedMessage } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import useClearFilters from "@app/util/hook/useClearFilters";

import styles from "./ResetButton.module.scss";

interface Props {}

const ResetButton: React.FC<Props> = () => {
  const handleResetAllFilters = useClearFilters();

  return (
    <Button className={styles.container} onClick={handleResetAllFilters} type="link">
      <FormattedMessage
        id="grid.overlay.noRows.resetButton"
        defaultMessage="Reset all filters"
        description="Title of reset filter button"
      />
    </Button>
  );
};

export default ResetButton;
